import { render } from "./SynodicOrbitObjectDetails.vue?vue&type=template&id=ba61682c"
import script from "./SynodicOrbitObjectDetails.vue?vue&type=script&lang=js"
export * from "./SynodicOrbitObjectDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__